// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"r9-z"};